<template>
  <router-view/>
</template>


<script>


export default ({
  created(){
    if (localStorage.getItem('localization')){
      this.$store.commit('SET_Lang',localStorage.getItem('localization'))
    }
  }
})

</script>
